import Box from "@/components/Box";
import InviteYourPatientForm from "@/components/organisations/patients/forms/InviteYourPatientForm";
import { useOrganisationContext } from "@/contexts/organisations/OrganisationContext";
import { CMP_PATIENTS_MANAGE_PATIENTS_URL } from "@/core/urls";
import useCmpRelatedUrl from "@/hooks/organisations/useCmpRelatedUrl";
import PatientAddedIcon from "@/images/PatientAddedIcon";
import ChevronComponent from "@/tpo/Chevron";
import Group from "@/tpo/Group";
import LinkWrapper from "@/tpo/LinkWrapper";
import Modal from "@/tpo/Modal";
import Stack from "@/tpo/Stack";
import ButtonV2 from "@/v2/Buttons";

export default function InvitePatientModal({ show, close }) {
  const { resolvedUrls } = useCmpRelatedUrl();
  const { organisation } = useOrganisationContext();

  return (
    <Modal
      show={show}
      close={close}
      maxWidth={1020}
      mode={["fullScreen", "fullScreen", "centered"]}
      closeButton
      bg="white"
      borderRadius={[0, 0, 20]}
      headerProps={{
        p: [20, 20, 40]
      }}
      data-component-name="InvitePatientModal"
    >
      <Stack px={[20, 20, 40]} pb={80} gap={0}>
        <Group width="100%" alignItems="center" justifyContent="space-between" gap={16}>
          <Group alignItems="center" gap={16} minWidth={0}>
            <PatientAddedIcon size={60} withCircle />
            <Box fontFamily="gilroyBold" fontSize={32} lineHeight="130%">
              Patients
            </Box>
          </Group>
          <ButtonV2
            color="dark"
            size="xs"
            as={LinkWrapper}
            to={resolvedUrls[CMP_PATIENTS_MANAGE_PATIENTS_URL]}
            rightIcon={<ChevronComponent />}
            onClick={close}
          >
            view all patients
          </ButtonV2>
        </Group>
        <Box fontFamily="gilroyBold" fontSize={18} lineHeight="130%" mt={28}>
          Quick add
        </Box>
        <Box fontFamily="gilroyMedium" fontSize={16} lineHeight="150%" mt={16}>
          Add a new patient and optionally send them an invite to the patient platform.
          <br />
          Or share your unique registration link :{" "}
          <Box as="span" color="anchorBlue" wordWrap="break-word">
            {organisation?.patientRegistrationUrl}
          </Box>
        </Box>
        <Box mt={40}>
          <InviteYourPatientForm submitButtonLabel="add patient" onSuccess={close} />
        </Box>
      </Stack>
    </Modal>
  );
}
